module.exports = __webpack_public_path__ + "img/3.31c1ab39.png";